import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Retronet from "./pages/Retronet";
import ICGC from "./pages/ICGC";
import Mooz from "./pages/Mooz";
import Footer from "./components/Footer";
import "./styles/stylesheet.scss";

function App() {
  return (
    <div className="app">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects/icgc" element={<ICGC />} />
        <Route path="/projects/mooz" element={<Mooz />} />
        <Route path="/projects/retronet" element={<Retronet />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
